module.exports = __webpack_public_path__ + "img/user_icon.22e09537.svg";